var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-width-1-1@l uk-width-1-1@m  uk-width-1-1@s section1",attrs:{"grid":""}},[_c('p',{staticClass:"uk-text-center Description"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }